import type {
  AccentColor,
  AccentShade,
  ThemeConfig,
} from 'src/types/customizing';

export const getThemeConfig = (): ThemeConfig => window.themeConfig ?? {};

export const isGradientEnabled = () => getThemeConfig().useGradient ?? true;

export const getAccentColor = (): AccentColor =>
  getThemeConfig().accentColor ?? 'secondary';

export const getAccentShade = (): AccentShade =>
  getThemeConfig().accentShade ?? 500;
